import * as React from 'react';
import { SessionMetadata } from '../../../cough/analyse/interfaces/state';

interface ItemMetadataProps {
    metadata: SessionMetadata;
}

export class ItemMetadata extends React.Component<ItemMetadataProps> {
    constructor(props: ItemMetadataProps) {
        super(props);
    }

    render() {
        if (this.props.metadata) {
            return (
                <div className="panel panel-default">
                    <div className="panel-body">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Study</th>
                                    <th>Site Number</th>
                                    <th>Subject Number</th>
                                    <th>Technician</th>
                                    <th>Visit Name</th>
                                    <th>Session Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{this.props.metadata.study}</td>
                                    <td>{this.props.metadata.siteNumber}</td>
                                    <td>{this.props.metadata.subjectNumber}</td>
                                    <td>{this.props.metadata.technician ? this.props.metadata.technician : "-" }</td>
                                    <td>{this.props.metadata.visitName}</td>
                                    <td>{this.props.metadata.sessionName}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}
